import React from 'react';
import { render } from 'react-dom';
import './privacy.css';
const langPackMap = {
    // cn: {
    //   title: '用户协议及隐私保护',
    //   content:
    //     '为了更好的保障您的合法权限，请您阅读并滑动同意以下协议 <a class="privacy_link" rel="noopener" target="_blank" href="https://page.cainiao.com/cn/docs/#/content/globalcs_privacy_updated">《隐私协议》</a>',
    // },
    en: {
        title: 'Privacy Protection',
        content: 'To better protect your legal rights, please read and swipe to agree to the following agreement <a class="privacy_link" rel="noopener" target="_blank" href="https://page.cainiao.com/cn/docs/#/content/globalcs_privacy_updated">Privacy Agreement</a>',
    },
    es: {
        title: 'Protección de la Privacidad',
        content: 'Para proteger mejor sus derechos legales, por favor lea y deslice para aceptar el siguiente acuerdo <a class="privacy_link" rel="noopener" target="_blank" href="https://page.cainiao.com/cn/docs/#/content/globalcs_privacy_updated">Acuerdo de Privacidad</a>',
    },
    fr: {
        title: 'Protection de la Vie Privée',
        content: 'Pour mieux protéger vos droits légaux, veuillez lire et faire glisser pour accepter l\'accord suivant <a class="privacy_link" rel="noopener" target="_blank" href="https://page.cainiao.com/cn/docs/#/content/globalcs_privacy_updated"> Accord de Confidentialité</a>',
    },
    ru: {
        title: 'Защита конфиденциальности',
        content: 'Для защиты ваших прав и персональных данных прочитайте "<a class="privacy_link" rel="noopener" target="_blank" href="https://page.cainiao.com/cn/docs/#/content/globalcs_privacy_updated">Соглашение о конфиденциальности</a>" и сдвиньте бегунок для согласия',
    },
    pt: {
        title: 'Proteção de Privacidade',
        content: 'Para melhor garantir seus direitos legais, por favor, leia e deslize para aceitar o seguinte acordo: "<a class="privacy_link" rel="noopener" target="_blank" href="https://page.cainiao.com/cn/docs/#/content/globalcs_privacy_updated">Acordo de Privacidade</a>"',
    },
    he: {
        rtl: true,
        title: 'הגנת פרטיות',
        content: `
      <div>
      "<a class="privacy_link" rel="noopener" target="_blank" href="https://page.cainiao.com/cn/docs/#/content/globalcs_privacy_updated">הסכם פרטיות</a>" כדי להגן טוב יותר על זכויותיך המשפטיות, אנא קרא והחלק כדי להסכים להסכם הבא
</div>
    `,
    },
};
const Privacy = ({ title, content, rtl, }) => {
    return (<div style={{
            direction: rtl ? 'rtl' : 'unset',
        }}>
      <h2 className={'privacy-title'}>{title}</h2>

      <p className={'privacy-content'} dangerouslySetInnerHTML={{ __html: content }}/>
    </div>);
};
// see more: https://project.aone.alibaba-inc.com/v2/project/1129818/req/64288795
export default (currLanguage, customEl) => {
    const lang = currLanguage in langPackMap
        ? langPackMap[currLanguage]
        : null;
    if (!lang)
        return;
    const div = document.createElement('div');
    div.id = 'cn_privacy_container';
    const ncRoot = customEl || document.getElementById('nc_token');
    if (ncRoot) {
        ncRoot.prepend(div);
    }
    render(<Privacy {...lang}/>, div);
};
